module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "title": "商户信息",
      "visible": _vm.dialogVisible,
      "destroy-on-close": "",
      "before-close": _vm.handleDialogClose
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "businessUserForm",
    attrs: {
      "label-width": "auto",
      "model": _vm.businessUser,
      "label-position": _vm.position,
      "rules": _vm.businessUserRules,
      "required-asterisk": "",
      "center": ""
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "用户",
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "用户",
      "clearable": ""
    },
    model: {
      value: (_vm.businessUser.name),
      callback: function($$v) {
        _vm.$set(_vm.businessUser, "name", $$v)
      },
      expression: "businessUser.name"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "手机号",
      "prop": "phone"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "手机号",
      "clearable": ""
    },
    model: {
      value: (_vm.businessUser.phone),
      callback: function($$v) {
        _vm.$set(_vm.businessUser, "phone", $$v)
      },
      expression: "businessUser.phone"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "地址",
      "prop": "address"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "地址",
      "clearable": ""
    },
    model: {
      value: (_vm.businessUser.address),
      callback: function($$v) {
        _vm.$set(_vm.businessUser, "address", $$v)
      },
      expression: "businessUser.address"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "openid",
      "prop": "openid"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "openid",
      "clearable": ""
    },
    model: {
      value: (_vm.businessUser.openid),
      callback: function($$v) {
        _vm.$set(_vm.businessUser, "openid", $$v)
      },
      expression: "businessUser.openid"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "unionid",
      "prop": "unionid"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "unionid",
      "clearable": ""
    },
    model: {
      value: (_vm.businessUser.unionid),
      callback: function($$v) {
        _vm.$set(_vm.businessUser, "unionid", $$v)
      },
      expression: "businessUser.unionid"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "appid",
      "prop": "appid"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "appid",
      "clearable": ""
    },
    model: {
      value: (_vm.businessUser.appid),
      callback: function($$v) {
        _vm.$set(_vm.businessUser, "appid", $$v)
      },
      expression: "businessUser.appid"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "required": "",
      "label": "工程师",
      "prop": "engineerId"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "工程师",
      "clearable": ""
    },
    model: {
      value: (_vm.businessUser.engineerId),
      callback: function($$v) {
        _vm.$set(_vm.businessUser, "engineerId", $$v)
      },
      expression: "businessUser.engineerId"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "备注",
      "prop": "memo"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "备注",
      "clearable": ""
    },
    model: {
      value: (_vm.businessUser.memo),
      callback: function($$v) {
        _vm.$set(_vm.businessUser, "memo", $$v)
      },
      expression: "businessUser.memo"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "是否要支付",
      "prop": "payFlag"
    }
  }, [_c('el-switch', {
    attrs: {
      "active-color": "#13ce66",
      "inactive-color": "#ff4949",
      "active-value": "1",
      "inactive-value": "0",
      "active-text": "是",
      "inactive-text": "否"
    },
    model: {
      value: (_vm.businessUser.payFlag),
      callback: function($$v) {
        _vm.$set(_vm.businessUser, "payFlag", $$v)
      },
      expression: "businessUser.payFlag"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "手艺人类型",
      "prop": "craftsmanType"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.businessUser.craftsmanType),
      callback: function($$v) {
        _vm.$set(_vm.businessUser, "craftsmanType", $$v)
      },
      expression: "businessUser.craftsmanType"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "金牌手艺人",
      "value": "0"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "爱回收手艺人",
      "value": "5"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "爱回收保险手艺人",
      "value": "7"
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "medium"
    },
    on: {
      "click": _vm.handlerSave
    }
  }, [_vm._v("保存")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "medium"
    },
    on: {
      "click": _vm.handleDialogClose
    }
  }, [_vm._v("取 消")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// /opt/devenv/allscs-jhh/repair-ui/~/vue-loader/lib/template-compiler?{"id":"data-v-1f315aa5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!/opt/devenv/allscs-jhh/repair-ui/~/vue-loader/lib/selector.js?type=template&index=0!./src/views/basicSetting/businessUser/module/index.vue
// module id = 1610
// module chunks = 0